import { Redirect, Stack } from 'expo-router';
import { useAuth } from '~/auth/contexts/auth/Auth';

export default function AuthLayout() {
  const { auth, isLoadingAuth } = useAuth();
  // While auth is still resolving, hold on the splash rather than flashing login.
  if (isLoadingAuth) {
    return null;
  }
  if (auth) {
    return <Redirect href="/(private)" />;
  }
  return (
    <Stack screenOptions={{ headerShown: false }}>
      <Stack.Screen name="index" />
    </Stack>
  );
}
